module.exports = __webpack_public_path__ + "img/gmri-ACTII-map-1100x690.b9600d9a.png";